import { NewsAbstraction, withCommonNews } from './NewsAbstract';

class NewsDetail extends NewsAbstraction {

    protected renderNewsContent(): JSX.Element {
        const userObject = this.getUserObject();
        const config = this.props.appServices.config;

        return (
            <eee-app-news-open_article
                user={JSON.stringify(userObject)}
                mfebaseurl={`${config.toxnotWebAppUrlEndpoint}/News`}
                openedarticleurl={config.newsOpenedArticleUrl}
                articleImpactmfeTitle="Article Impact"
                articleImpactDataApiUrl={`${config.toxnotWebAppUrlEndpoint}/Api/GetArticleImpact`}
                substanceImpactTitle="Substance Impact"
                substanceImpactDataApiUrl={`${config.toxnotWebAppUrlEndpoint}/Api/GetSubstanceImpact`}
                hideothermfes="false"
                bffurlparameter={config.newsBffBaseUrl}
            >
            </eee-app-news-open_article>
        );
    }
}

export default withCommonNews(NewsDetail);